/* tslint:disable */
/* eslint-disable */
/**
 * DAM PORTAL API
 * API for handling DAM PORTAL operations.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OktaConfig
 */
export interface OktaConfig {
    /**
     * 
     * @type {string}
     * @memberof OktaConfig
     */
    issuer?: string;
    /**
     * 
     * @type {string}
     * @memberof OktaConfig
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof OktaConfig
     */
    registrationLink?: string;
}

export function OktaConfigFromJSON(json: any): OktaConfig {
    return OktaConfigFromJSONTyped(json, false);
}

export function OktaConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): OktaConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'issuer': !exists(json, 'issuer') ? undefined : json['issuer'],
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'registrationLink': !exists(json, 'registrationLink') ? undefined : json['registrationLink'],
    };
}

export function OktaConfigToJSON(value?: OktaConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'issuer': value.issuer,
        'clientId': value.clientId,
        'registrationLink': value.registrationLink,
    };
}

